// src/App.tsx
import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { vendorChatWebSocket } from './services/message/websocket';

function App() {
  useEffect(() => {
    return () => {
      vendorChatWebSocket.disconnectAll();
    };
  }, []);

  return <RouterProvider router={router} />;
  // future={{ v7_startTransition: true }}
}

export default App;
